var map = {
	"./arrow-top.svg": "ad83",
	"./code.svg": "d7a0",
	"./code2.svg": "c659",
	"./edit.svg": "2fb0",
	"./edit2.svg": "11f4",
	"./hotelsafe.svg": "63ec",
	"./message.svg": "15e8",
	"./message2.svg": "cdd0",
	"./message_light.svg": "fb5a",
	"./mms.svg": "8035",
	"./paper-plane.svg": "512e",
	"./plane.svg": "3740",
	"./safe.svg": "e3a0",
	"./secure.svg": "339f",
	"./tools.svg": "e46f",
	"./voice.svg": "d047"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f853";